import { render } from "./MinimizedCallWindow.vue?vue&type=template&id=3215c88f&scoped=true"
import script from "./MinimizedCallWindow.vue?vue&type=script&lang=js"
export * from "./MinimizedCallWindow.vue?vue&type=script&lang=js"

import "./MinimizedCallWindow.vue?vue&type=style&index=0&id=3215c88f&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3215c88f"]])

export default __exports__